import { KeycloakService } from 'keycloak-angular';
import { environment } from '../environments/environment';

export function isFromUploader(): boolean {
  const href = window.location.href;
  return (
    href.includes('from=skipper-uploader') ||
    href.includes('from%3Dskipper-uploader')
  );
}

export function resolveRealm(): string | null {
  const fromUrl = new URLSearchParams(window.location.search).get('realm');
  if (fromUrl) {
    return fromUrl;
  }

  if (isFromUploader()) {
    return environment.KC_REALMS[0]?.id || null;
  }
 
  return null;
}

export function isLoginRoute(): boolean {
  return window.location.hash.includes('#/login');
}

function appBasePath(): string {
  const base = document.querySelector('base')?.getAttribute('href') || '/';
  return base.endsWith('/') ? base : `${base}/`;
}

export function keycloakRedirectUri(realm: string): string {
  return `${window.location.origin}${appBasePath()}?realm=${encodeURIComponent(realm)}`;
}

export function initKeycloakForRealm(
  keycloak: KeycloakService,
  realm: string
): Promise<boolean> {
  return keycloak.init({
    config: {
      url: environment.KC_URL,
      realm,
      clientId: environment.KC_CLIENT_ID,
    },
    initOptions: {
      onLoad: 'check-sso',
      redirectUri: keycloakRedirectUri(realm),
    },
  });
}

export function initKeycloakForLogin(
  keycloak: KeycloakService,
  realm: string
): Promise<boolean> {
  return keycloak.init({
    config: {
      url: environment.KC_URL,
      realm,
      clientId: environment.KC_CLIENT_ID,
    },
    initOptions: {
      onLoad: 'login-required',
      redirectUri: keycloakRedirectUri(realm),
    },
  });
}

export function homeUrl(realm: string): string {
  return `${keycloakRedirectUri(realm)}#/`;
}
